export default class NavHeight {
    constructor() {
        this.navHeightValue = this.calculateNavHeight();
    }

    calculateNavHeight() {
        const navElement = document.querySelector('.nav-menu');
        if (navElement) {
            const navHeightValue = navElement.offsetHeight;
            document.documentElement.style.setProperty('--nav-height', `${navHeightValue}px`);
            return navHeightValue;
        }
        return 0;
    }
}
